var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFramePink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 216,
    height: 155,
    viewBox: "0 0 216 155",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22490",
    "data-name": "Rectangle 22490",
    width: 216,
    height: 155,
    rx: 6,
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17192",
    "data-name": "Rectangle 17192",
    width: 5.684,
    height: 4,
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17193",
    "data-name": "Rectangle 17193",
    width: 3.789,
    height: 4,
    transform: "translate(0)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17192-2",
    "data-name": "Rectangle 17192",
    width: 3.789,
    height: 2,
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17193-2",
    "data-name": "Rectangle 17193",
    width: 5.553,
    height: 4.888,
    transform: "translate(0 -1.888)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17192-3",
    "data-name": "Rectangle 17192",
    width: 12.316,
    height: 13,
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17192-4",
    "data-name": "Rectangle 17192",
    width: 13.263,
    height: 14,
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17193-4",
    "data-name": "Rectangle 17193",
    width: 12.316,
    height: 13,
    transform: "translate(0)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("image", {
    id: "image",
    width: 29.46,
    height: 12.997,
    xlinkHref: "data:image/png;base64,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"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_25751",
    "data-name": "Mask Group 25751",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46574",
    "data-name": "Group 46574"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46474",
    "data-name": "Group 46474"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46467",
    "data-name": "Group 46467",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46480",
    "data-name": "Group 46480",
    transform: "translate(12.315 13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_17194",
    "data-name": "Rectangle 17194",
    d: "M4.412,3.211V125.873H187.066V3.211H4.412M0,0H191.477V129.084H0Z",
    transform: "translate(0.081 0.085)",
    fill: "#cea3af",
    stroke: "#cea3af",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_46477",
    "data-name": "Group 46477",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46475",
    "data-name": "Group 46475",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46472",
    "data-name": "Group 46472",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_25534",
    "data-name": "Mask Group 25534",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_132994",
    "data-name": "Line 132994",
    d: "M.009-.354l11.277,11.9-.362.383L-.354.029Z",
    transform: "translate(0.029 -0.023)",
    fill: "#e8c8d1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_25535",
    "data-name": "Mask Group 25535",
    transform: "translate(187.579 0)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_132994-2",
    "data-name": "Line 132994",
    d: "M10.923-.354-.354,11.549l.362.383L11.285.029Z",
    transform: "translate(-5.719 -1.269)",
    fill: "#e8c8d1"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_46476",
    "data-name": "Group 46476",
    transform: "translate(0.001 126)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46472-2",
    "data-name": "Group 46472",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_25534-2",
    "data-name": "Mask Group 25534",
    transform: "translate(187.578 1)",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_132994-3",
    "data-name": "Line 132994",
    d: "M10.923,11.932-.354.029.009-.354l11.277,11.9Z",
    transform: "translate(-6.9 -9.301)",
    fill: "#e8c8d1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_25535-2",
    "data-name": "Mask Group 25535",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_132994-4",
    "data-name": "Line 132994",
    d: "M.009,11.932,11.285.029l-.362-.383L-.354,11.549Z",
    transform: "translate(-0.562 -7.678)",
    fill: "#e8c8d1"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_46467-2",
    "data-name": "Group 46467",
    transform: "translate(12.315 143)"
  }, /*#__PURE__*/React.createElement("use", {
    id: "Image_2211",
    "data-name": "Image 2211",
    transform: "translate(0 -0.458)",
    xlinkHref: "#image"
  }), /*#__PURE__*/React.createElement("use", {
    id: "Image_2238",
    "data-name": "Image 2238",
    transform: "translate(28.478 -0.458)",
    xlinkHref: "#image"
  }), /*#__PURE__*/React.createElement("use", {
    id: "Image_2214",
    "data-name": "Image 2214",
    transform: "translate(85.433 -0.458)",
    xlinkHref: "#image"
  }), /*#__PURE__*/React.createElement("use", {
    id: "Image_2216",
    "data-name": "Image 2216",
    transform: "translate(142.389 -0.458)",
    xlinkHref: "#image"
  }), /*#__PURE__*/React.createElement("use", {
    id: "Image_2212",
    "data-name": "Image 2212",
    transform: "translate(56.956 -0.458)",
    xlinkHref: "#image"
  }), /*#__PURE__*/React.createElement("use", {
    id: "Image_2213",
    "data-name": "Image 2213",
    transform: "translate(113.911 -0.458)",
    xlinkHref: "#image"
  }), /*#__PURE__*/React.createElement("use", {
    id: "Image_2215",
    "data-name": "Image 2215",
    transform: "translate(171.358 -0.458)",
    xlinkHref: "#image"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46470",
    "data-name": "Group 46470"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46466",
    "data-name": "Group 46466",
    transform: "translate(11.368)"
  }, /*#__PURE__*/React.createElement("use", {
    id: "Image_2211-2",
    "data-name": "Image 2211",
    transform: "scale(0.965 0.965)",
    xlinkHref: "#image"
  }), /*#__PURE__*/React.createElement("use", {
    id: "Image_2214-2",
    "data-name": "Image 2214",
    transform: "translate(54) scale(0.965 0.965)",
    xlinkHref: "#image"
  }), /*#__PURE__*/React.createElement("use", {
    id: "Image_2216-2",
    "data-name": "Image 2216",
    transform: "translate(108) scale(0.965 0.965)",
    xlinkHref: "#image"
  }), /*#__PURE__*/React.createElement("use", {
    id: "Image_2212-2",
    "data-name": "Image 2212",
    transform: "translate(26.526) scale(0.965 0.965)",
    xlinkHref: "#image"
  }), /*#__PURE__*/React.createElement("use", {
    id: "Image_2213-2",
    "data-name": "Image 2213",
    transform: "translate(81.474) scale(0.965 0.965)",
    xlinkHref: "#image"
  }), /*#__PURE__*/React.createElement("use", {
    id: "Image_2215-2",
    "data-name": "Image 2215",
    transform: "translate(172.421) scale(0.965 0.965)",
    xlinkHref: "#image"
  }), /*#__PURE__*/React.createElement("use", {
    id: "Image_2239",
    "data-name": "Image 2239",
    transform: "translate(144.947) scale(0.965 0.965)",
    xlinkHref: "#image"
  }), /*#__PURE__*/React.createElement("use", {
    id: "Image_2240",
    "data-name": "Image 2240",
    transform: "translate(133.579) scale(0.965 0.965)",
    xlinkHref: "#image"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46468",
    "data-name": "Group 46468",
    transform: "translate(215.999) rotate(90)"
  }, /*#__PURE__*/React.createElement("use", {
    id: "Image_2211-3",
    "data-name": "Image 2211",
    transform: "scale(0.948 0.948)",
    xlinkHref: "#image"
  }), /*#__PURE__*/React.createElement("use", {
    id: "Image_2214-3",
    "data-name": "Image 2214",
    transform: "translate(54) scale(0.948 0.948)",
    xlinkHref: "#image"
  }), /*#__PURE__*/React.createElement("use", {
    id: "Image_2216-3",
    "data-name": "Image 2216",
    transform: "translate(99) scale(0.948 0.948)",
    xlinkHref: "#image"
  }), /*#__PURE__*/React.createElement("use", {
    id: "Image_2212-3",
    "data-name": "Image 2212",
    transform: "translate(26) scale(0.948 0.948)",
    xlinkHref: "#image"
  }), /*#__PURE__*/React.createElement("use", {
    id: "Image_2213-3",
    "data-name": "Image 2213",
    transform: "translate(79) scale(0.948 0.948)",
    xlinkHref: "#image"
  }), /*#__PURE__*/React.createElement("use", {
    id: "Image_2215-3",
    "data-name": "Image 2215",
    transform: "translate(126.916) scale(0.948 0.948)",
    xlinkHref: "#image"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46469",
    "data-name": "Group 46469",
    transform: "translate(12.316) rotate(90)"
  }, /*#__PURE__*/React.createElement("use", {
    id: "Image_2211-4",
    "data-name": "Image 2211",
    transform: "scale(0.948 0.948)",
    xlinkHref: "#image"
  }), /*#__PURE__*/React.createElement("use", {
    id: "Image_2214-4",
    "data-name": "Image 2214",
    transform: "translate(51) scale(0.948 0.948)",
    xlinkHref: "#image"
  }), /*#__PURE__*/React.createElement("use", {
    id: "Image_2216-4",
    "data-name": "Image 2216",
    transform: "translate(99.084) scale(0.948 0.948)",
    xlinkHref: "#image"
  }), /*#__PURE__*/React.createElement("use", {
    id: "Image_2212-4",
    "data-name": "Image 2212",
    transform: "translate(25) scale(0.948 0.948)",
    xlinkHref: "#image"
  }), /*#__PURE__*/React.createElement("use", {
    id: "Image_2213-4",
    "data-name": "Image 2213",
    transform: "translate(76) scale(0.948 0.948)",
    xlinkHref: "#image"
  }), /*#__PURE__*/React.createElement("use", {
    id: "Image_2215-4",
    "data-name": "Image 2215",
    transform: "translate(127) scale(0.948 0.948)",
    xlinkHref: "#image"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_46473",
    "data-name": "Group 46473"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46471",
    "data-name": "Group 46471",
    transform: "translate(0 142)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_25534-3",
    "data-name": "Mask Group 25534",
    transform: "translate(203.685)",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_132994-5",
    "data-name": "Line 132994",
    d: "M12.633,13.8-.354.087.064-.354,13.051,13.355Z",
    transform: "translate(0.039 -0.009)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_25535-3",
    "data-name": "Mask Group 25535",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_132994-6",
    "data-name": "Line 132994",
    d: "M.064,13.8,13.051.087l-.417-.441L-.354,13.355Z",
    transform: "translate(-0.15 -0.009)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_46472-3",
    "data-name": "Group 46472",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_25534-4",
    "data-name": "Mask Group 25534",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_132994-7",
    "data-name": "Line 132994",
    d: "M.064-.354,13.051,13.355l-.417.441L-.354.087Z",
    transform: "translate(-0.15 -0.178)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_25535-4",
    "data-name": "Mask Group 25535",
    transform: "translate(203.684)",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_132994-8",
    "data-name": "Line 132994",
    d: "M12.633-.354-.354,13.355l.417.441L13.051.087Z",
    transform: "translate(0.04 -0.178)",
    fill: "#fff"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFramePink);
export default __webpack_public_path__ + "static/media/frame_pink.8cae11748898a6444879acde4e4af412.svg";
export { ForwardRef as ReactComponent };